const EVENT_TYPES = {
  schoolEvent: "event",
  classEvent: "schedule",
  meetingEvent: "video conference",
  canceled: "canceled"
};

const REPEAT_TIMES = {
  Weekly: "weekly",
  Daily: "daily",
  Irregularly: "irregularly"
};

export default { EVENT_TYPES, REPEAT_TIMES };
